<app-expandable-section-box
  [title]="'Content Lists'"
  [iconClass]="'icon-language'"
  [isExpandable]="isExpandable"
  [isExpandedByDefault]="isExpandedByDefault"
>
  <app-search-list
    expandedContent
    [selectedList]="manuallySelectedList"
    [searchFormControl]="searchFormControl"
    [searchResults]="searchResults"
    [isInfoButtonShown]="false"
    [isAddButtonShown]="false"
    (handleRemove)="removeContentList($event)"
    (handleAdd)="addContentList($event)"
    class="flex flex-col flex-1"
  ></app-search-list>
  <div
    class="flex flex-col w-full py-4 pr-3 m-0 bg-project-2200"
    *ngIf="contentListControl.value?.length"
    data-testid="preview"
    notExpandedContent
  >
    <ng-container *ngFor="let selectedItem of manuallySelectedList">
      <p class="py-px text-xs text-project-2400">
        {{ selectedItem.displayName }}
      </p>
    </ng-container>
  </div>
</app-expandable-section-box>
